export default {"src":"/_next/static/media/morpho-blue.158f1575.svg","height":69,"width":74,"blurWidth":0,"blurHeight":0};